var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 115,
    viewBox: "0 0 154 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#b0bec5;}.a{fill-rule:evenodd;}.c{fill:#fff;}.d,.e{fill:none;}.d{stroke:#b0bec5;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-459 -642)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-628.999 269.274)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1145.708 412.946)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.352,433.856h78.467a8.708,8.708,0,0,0,8.862-8.538v-.04l.048-23.73a8.748,8.748,0,0,0-8.91-8.578H37.348a8.77,8.77,0,0,0-8.91,8.578v23.73A8.775,8.775,0,0,0,37.352,433.856Zm0-28.023a4.374,4.374,0,0,1,4.455-4.289h69.557a4.374,4.374,0,0,1,4.455,4.289v14.008H37.348Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3.427,
    cy: 3.299,
    rx: 3.427,
    ry: 3.299,
    transform: "translate(51.333 14.402)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3.427,
    cy: 3.299,
    rx: 3.427,
    ry: 3.299,
    transform: "translate(61.94 14.402)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3.427,
    cy: 3.299,
    rx: 3.427,
    ry: 3.299,
    transform: "translate(72.36 14.402)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1088 414.402)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 17,
    cy: 16,
    rx: 17,
    ry: 16,
    transform: "translate(-0.001 0.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.931,0l7.931,14.695H0Z",
    transform: "translate(25.241 9.04) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17,17A16.891,16.891,0,0,1,4.98,12.021,16.886,16.886,0,0,1,0,0H34a16.887,16.887,0,0,1-4.979,12.021A16.887,16.887,0,0,1,17,17Z",
    transform: "translate(1087.999 391.726)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1098.546 384.555)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.931,0l7.931,14.695H0Z",
    transform: "translate(14.695 0) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34,17H0A17,17,0,0,1,29.021,4.979,16.885,16.885,0,0,1,34,17Z",
    transform: "translate(1087.999 451.726)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1098.546 461.647)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.931,0l7.931,14.695H0Z",
    transform: "translate(14.695 0) rotate(90)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 21,
    height: 10,
    transform: "translate(1144.999 425.726)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1132.443 423.951)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 29.153,
    transform: "translate(0 6.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.2,0l7.2,13.169H0Z",
    transform: "translate(39.927) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 7.635,
    transform: "translate(21.517 6.915)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 154,
    height: 115,
    transform: "translate(1087.999 372.726)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStep2);
export default __webpack_public_path__ + "static/media/img_step2.4eafa1baa125b421e7cc7a93f5f24e29.svg";
export { ForwardRef as ReactComponent };